import { render, staticRenderFns } from "./init-history.vue?vue&type=template&id=33fe61c8"
import script from "./init-history.vue?vue&type=script&lang=js"
export * from "./init-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports